module.exports = [
	{
		"title": "Machine to Machine Auth",
		"description": "Easily facilitate secure communication between your API and both non interactive external clients as well as internal APIs with the flip of a switch and standard based protocols.",
		"logoUrl": "https://cdn.auth0.com/website/assets/pages/pricing/img/icon-machine-to-machine-127c3edf7e.svg",
		"list": [
			{
				"iconUrl": "https://cdn.auth0.com/website/assets/pages/pricing/img/icon-bill-47043b8cd2.svg",
				"text": "Priced by API calls",
				"tooltip": "Every time you issue a token in Auth0"
			},
			{
				"iconUrl": "https://cdn.auth0.com/website/assets/pages/pricing/img/icon-building-083a3c090f.svg",
				"text": "Available as an enterprise standalone product"
			}
		],
		"readMoreUrl": "https://auth0.com/docs/api-auth/grant/client-credentials"
	},
	{
		"title": "MFA with Guardian",
		"description": "The most usable and friction-free multifactor authentication experience available. Use the Guardian iOS or Android app to receive push notifications, get one-time codes delivered via SMS or connect with a third party token generation app such as Google Authenticator.",
		"logoUrl": "https://cdn.auth0.com/website/assets/pages/pricing/img/guardian-logo-510772a3a5.svg",
		"readMoreUrl": "https://auth0.com/multifactor-authentication"
	},
	{
		"title": "Anomaly Detection",
		"description": "Keep your users and services safe from password leaks and intruders. Protect and notify your users when credentials are leaked or when somebody is trying to force their way into their account.",
		"logoUrl": "https://cdn.auth0.com/website/assets/pages/pricing/img/breached-passwords-logo-ddbcd43a85.svg",
		"readMoreUrl": "https://auth0.com/breached-passwords"
	},
	{
		"title": "OAuth as a Service",
		"description": "Grow Your Business by Building a Secure Ecosystem Around Your APIs. Increase market reach, provide better user experiences, and grow your userbase by easily securing and exposing your APIs to partners and third party clients with the flip of a switch.",
		"logoUrl": "https://cdn.auth0.com/website/assets/pages/pricing/img/icon-oauth-a8a5d7c850.svg",
		"readMoreUrl": "https://auth0.com/docs/api-auth/user-consent"
	},
	{
		"title": "SLA 99.95%",
		"description": "Auth0 commits to deliver 99.95% level of end-user availability of service, with financial incentives to perform.",
		"logoUrl": "https://cdn.auth0.com/website/assets/pages/pricing/img/icon-sla-9995-a6257c73dc.svg",
		"readMoreUrl": "https://auth0.com/docs/support/sla"
	},
	{
		"title": "Preferred Support",
		"description": "Preferred level of support agreement that includes extended support hours including an available 24/7 option with 1 hour response time and a dedicated customer success manager to help you with your on boarding and on going experience with Auth0.",
		"logoUrl": "https://cdn.auth0.com/website/assets/pages/pricing/img/icon-premium-support-dcd8155364.svg",
		"readMoreUrl": "https://auth0.com/docs/support"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/pages/pricing/data/addons.json
// module id = 1428
// module chunks = 0